export default [
    {
        path: "/",
        component: () => import('../views/LoadingScreen.vue'),
        name: "LoadingScreen"
    }
    , {
        path: "/cards",
        component: () => import('../views/ProductList.vue'),
        name: "ProductList"
    },
    {
        path: "/cart",
        component: () => import('../views/Cart.vue'),
        name: "Cart"
    },
    {
        path: "/delivery-options",
        component: () => import('../views/DeliveryOptions.vue'),
        name: "DeliveryOptions"
    },
    {
        path: "/summary",
        component: () => import('../views/Summary.vue'),
        name: "Summary"
    },
    {
        path: '*',
        redirect: '/'
    }
]